import React from "react";
// pets
import yogi from "../../images/new/pets/yogi.png";
import alice from "../../images/new/pets/alice.png";
import boo from "../../images/new/pets/boo.png";
import cosmic from "../../images/new/pets/cosmic.png";
import dynasty from "../../images/new/pets/dynasty.png";
import eppie from "../../images/new/pets/eppie.png";
import flo from "../../images/new/pets/flo.png";
import jinx from "../../images/new/pets/jinx.png";
import kinoko from "../../images/new/pets/kinoko.png";
import leya from "../../images/new/pets/leya.png";
import mushie from "../../images/new/pets/mushy.png";
import nirvana from "../../images/new/pets/nirvana.png";
import otto from "../../images/new/pets/otto.png";
import praise from "../../images/new/pets/praise.png";
import quinn from "../../images/new/pets/quinn.png";
import sage from "../../images/new/pets/sage.png";
import unique from "../../images/new/pets/unique.png";
import violet from "../../images/new/pets/violet.png";
import winnie from "../../images/new/pets/winnie.png";
import grace from "../../images/new/pets/grace.png";
import hazey from "../../images/new/pets/hazey.png";
import lggy from "../../images/new/pets/lggy.png";
import ruby from "../../images/new/pets/ruby.png";
import treasure from "../../images/new/pets/treasure.png";
import xoxo from "../../images/new/pets/xoxo.png";
import zen from "../../images/new/pets/zen.png";
import { useEffect } from "react";
// importing aos
import AOS from "aos";
import "aos/dist/aos.css";
function PetsSlider() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);
  return (
    <section id="collection-pets">
      <div className="wrapper">

        {/* Pets */}
        <div className="pets">
          <h2>Pets</h2>
          <p>A pet makes everything better!</p>
          <p>
            If your Hippie comes with a trusted sidekick, you will be eligible
            for additional utility, including a free pet mint!
          </p>
          <div className="scroll-pets loop-slider-pet">
            <div className="inner-pet slownormalDirection">
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={yogi} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>yogi</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={alice} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>alice</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={boo} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>boo</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={cosmic} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>cosmic</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={dynasty} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>dynasty</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={eppie} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>eppie</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={flo} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>flo</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={jinx} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>jinx</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={kinoko} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>kinoko</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={leya} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>leya</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={mushie} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>Mushie</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={nirvana} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>nirvana</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={otto} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>otto</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={praise} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>praise</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={quinn} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>quinn</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={sage} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>sage</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={unique} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>unique</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={violet} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>violet</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={winnie} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>winnie</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={grace} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>grace</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={hazey} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>hazey</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={lggy} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>lggy</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={ruby} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>ruby</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={treasure} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>treasure</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={xoxo} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>xoxo</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={zen} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>zen</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default PetsSlider;
